import React from 'react'
import * as ProductIcons from 'components/ProductIcons'
import * as NotProductIcons from 'components/NotProductIcons'
import { prepareData } from 'utils/googleData'

export const LeadingProofBox = (props) => {
    const {
        enable,
        items,
        className = '',
    } = prepareData({
        props,
    })
    if (enable?.toLowerCase?.() === 'false' && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>
    }

    return (
        <ul className="m-0 grid w-full flex-grow list-none grid-cols-2 border-b border-r border-dashed border-gray-accent-light p-0 md:grid-cols-4">
            {items?.length > 0
                ? items?.map(({ name, icon, url }, index) => {
                      const Icon = NotProductIcons[icon] || ProductIcons[icon]
                      return (
                          <dev key={name}>
                              <li
                                  key={name}
                                  className="flex h-24 w-full items-center justify-center border-t border-l border-dashed border-gray-accent-light py-6 lg:h-40 lg:px-2"
                              >
                                  {Icon && (
                                      <Icon
                                          key={name}
                                          className={`icon max-h-[50px]" px-4 md:px-6 lg:px-4 ${className}`}
                                      />
                                  )}
                                  <h4 key={name} className="text-center text-base font-semibold leading-tight">
                                      {name}
                                  </h4>
                              </li>
                          </dev>
                      )
                  })
                : ''}
        </ul>
    )
}
export default LeadingProofBox
